import React from 'react'
import styled from 'styled-components'
import { SCARLET_THEME } from '@constants/theme-prefs'

const { textColor, mainColor } = SCARLET_THEME

interface NavOption {
  linkText: string
  linkUrl?: string
}

const siteNavOptions: NavOption[] = [
  { linkText: 'Home' },
  { linkText: 'Browse' },
  { linkText: 'Search' },
  { linkText: 'Messages' },
  { linkText: 'Blog' },
  { linkText: 'Bulletins' },
  { linkText: 'Forum' },
  { linkText: 'Groups' },
  { linkText: 'Layouts' },
  { linkText: 'Favs' },
  { linkText: 'Invite' },
  { linkText: 'About' },
]

const userNavOptions: NavOption[] = [
  { linkText: 'Help' },
  { linkText: 'Login' },
  { linkText: 'Sign Up' },
]

const NavMenu = styled.ul`
  list-style-type: none;
  margin: 0;
  padding: 10px;
  display: flex;
  flex-wrap: wrap;

  & > li:last-of-type {
    margin-right: 0;
  }
`

const NavLink = styled.li`
  font-weight: bold;
  margin-right: 10px;

  & > a {
    color: ${textColor};
    text-decoration: none;
  }

  & > a:hover {
    color: ${mainColor};
  }
`

const TopNav = styled.div`
  padding: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  & > h1 {
    margin: 0;
  }
`

export default function NavBar () {
  return (
    <nav>
      <TopNav>
        <h1>DogSpace</h1>
        <form>
          <label htmlFor={'search'}>Search users</label>
          <input type={'text'} name={'search'} id={'search'} />
          <input type={'submit'} value={'Search'} />
        </form>
        <NavMenu>
          { userNavOptions.map((option, index) => <NavLink key={ index }><a href="#">{ option.linkText }</a></NavLink> )}
        </NavMenu>
      </TopNav>
      <NavMenu>
        { siteNavOptions.map((option, index) => <NavLink key={ index }><a href="#">{ option.linkText }</a></NavLink> )}
      </NavMenu>
    </nav>
  )
}